<script setup lang="ts">
import { definePage } from "unplugin-vue-router/runtime";
import { useRoute } from "vue-router";
import { useAbility } from "@casl/vue";
import NextAddEdit from "@/components/models/patient/forms/visitInstructions/NextAddEdit.vue";
import { useNextVisitInstructionV2ById } from "@/composables/models/patient/visitInstructions/useNext.ts";

definePage({
  meta: {
    title: "generic.action.addEntity",
    titleParams: { entity: "generic.entity.nextVisitInstructions" },
    checkPrivileges: () => {
      const { can } = useAbility();
      return (
        can($permActions.CREATE, $permSubjects.PATIENT__NEXTVISITINSTRUCTIONSV2) ||
        can($permActions.UPDATE, $permSubjects.PATIENT__NEXTVISITINSTRUCTIONSV2)
      );
    },
  },
});

const route = useRoute();
const routeParams = route.params as { id: string };
const { data: instructions, isLoading } = useNextVisitInstructionV2ById({ id: routeParams.id });
</script>

<template>
  <v-skeleton-loader :loading="isLoading">
    <next-add-edit
      :next-visit-instructions="instructions"
      creating
    />
  </v-skeleton-loader>
</template>

<style scoped></style>
